import { IDataSet } from '../Track';

export class MissionDataSet implements IDataSet {
    public missionID: string = undefined;
    public missionName: string = undefined;

    public mLevel: number = undefined;

    //public mLevelID: string = undefined;
    //public mLevelDifficulty: string = undefined;
    //public mLevelHard: number = undefined;

    public mLevelType: string = "ALL_CARDS";

    /**
     * Number of cards to clear to win the level:
     * ALL_CARDS = number of 'in-play' cards
     * GOLD_CARDS = number of golden cards
     */
    public mGoalAmount: number = 0;
    public mRetryNum: number = 0;
    public mIsSuccessfulRetry: number = 0;

    /**
     * Number of cards given in stack.
     */
    public mLevelMoves: number = 0;

    public mHighestPlayStreak: number = 0;

    /**
     * Number of shuffle boosters used in current level.
     */
    public mChangerUsed: number = 0;

    /**
     * Number of bulls-eye boosters used in current level.
     */
    public mRemoveOneUsed: number = 0;

    /**
     * Number of TNT boosters used in current level.
     */
    public mMassRemoveUsed: number = 0;
    public mJokerUsed: number = 0;
    public mUndoUsed: number = 0;

    public mExtraCardsBought: number = 0;
    public mExtraCardsWon: number = 0;
    public mCoinsSpent: number = 0;

    public mNoActionCardStreak: number = 0;
    public mNoPossibleActionStreak: number = 0;

    /**
     * Number of cards cleared as a percentage:
     * ALL_CARDS percent of initial 'in-play' cards.
     * GOLD_CARDS percent of initial 'golden' cards.
     */
    public mGoalsCompletedPercentage: number = undefined;

    public mFriendHelped: boolean = false;
    public mFriendWhoHelped: string = undefined;

    public mCardsLeft: number = undefined;

    public mStars: number = undefined;

    public mLossAversionCoinsSpent: number = 0;

    public mScore: number = undefined;
    public mScoreBeforeEndSequence: number = undefined;

    public mCoinsBoughtWithRealMoney: number = undefined;
    public mBoostersBoughtWithRealMoney: number = undefined;

    public mLevelTypeContext: string = undefined;
}
